module.exports = __webpack_public_path__ + "static/media/horizontalBalls.5450efc4.svg";